import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import Loader from "./components/common/Loader/index.jsx";

const Login = React.lazy(() => import('./components/Login/loginpage.jsx'))
const Layout = React.lazy(() => import('./components/Layout/layout.jsx'))

const Home = React.lazy(() => import('./components/Home/home.jsx'));
const PUMCHome = React.lazy(() => import('./components/PUMCHome/home.jsx'));
const UserReports = React.lazy(() => import('./components/UserReports/userReports.jsx'));
const Financials = React.lazy(() => import('./components/Financials/financials.jsx'));
const Contracts = React.lazy(() => import('./components/Contracts/contracts.jsx'));
const AISolutions = React.lazy(() => import('./components/AISolutions/aiSolutions.jsx'));
const Planning = React.lazy(() => import('./components/ExtendedPlanning/planning.jsx'));
const Employees = React.lazy(() => import('./components/Employees/employees.jsx'));
const DataMgt = React.lazy(()=> import('./components/DataManagement/dataManagement.jsx') );
const PLFileUpload = React.lazy(()=> import('./components/DataManagement/PLFileUpload/plFileUpload.jsx'))
const CustomersDashboard = React.lazy(()=> import('./components/Customers/customers.jsx'))
const AIAnomalyDetection = React.lazy(()=> import('./components/Property/AIAnomali/aiAnomali.jsx'))
const Receivables = React.lazy(() => import('./components/Receivables/receivables.jsx'));

const AnalyticStudio = React.lazy(() => import('./components/AnalyticStudio/analyticStudio.jsx'));

const ProjectManagement = React.lazy(() => import('./components/ProjectManagement/index.jsx'));
const PMInsights = React.lazy(()=> import ('./components/ProjectManagement/Insights/projectManagementInsights.jsx'))
const MSPFileUpload = React.lazy(()=> import('./components/DataManagement/MSPFileUpload/mspFileUpload.jsx'))

const RAWDataUploads = React.lazy(()=> import('./components/DataManagement/RawDataUploads/index.jsx'))

const Reserves = React.lazy(() => import('./components/Home/reserves.jsx'))
const OperationalExcellence = React.lazy(() => import('./components/Home/operationalExcellence.jsx'))
const CEODashboards = React.lazy(() => import('./components/Home/CEODashboards.jsx'))
const TechnologyCapability = React.lazy(() => import('./components/Home/technologyCapability.jsx'))
const Stakeholders = React.lazy(() => import('./components/Home/stakeholders.jsx'))

const ForgotPassword = React.lazy(()=> import ('./components/Login/forgotpassword.jsx'))
const UserManagement = React.lazy(() => import('./components/UserManagement/userManagement.jsx'))
const Insights = React.lazy(() => import('./components/Insights/insights.jsx'))
const PUMCInsights = React.lazy(() => import('./components/PUMCInsights/insights.jsx'))
const AssetManagement = React.lazy(()=> import('./components/AssetManagement/assetManagement.jsx'))

const InitiativesLanding = React.lazy(()=> import ('./components/Initiatives/initiatives.jsx'))
const CreateInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/create.jsx'))
const CadenceBoardInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/cadenceBoard.jsx'))
const ViewInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/view.jsx'))
const FCFImpactLanding = React.lazy(()=> import ('./components/Initiatives/FCFImpact'))


const FunctionalPlanning = React.lazy(() => import('./components/ExtendedPlanning/FunctionalPlanning/functionalPlanning.jsx'));
const SimulationPlanning = React.lazy(() => import('./components/ExtendedPlanning/SimulationPlanning/index.jsx'));
const KpiBasedPlanning = React.lazy(() => import('./components/ExtendedPlanning/KPIBasedPlanning/index.jsx'));
const DetailedPlanning = React.lazy(() => import('./components/ExtendedPlanning/DetailedPlanning/index.jsx'));
const IntegratedPlanning = React.lazy(() => import('./components/ExtendedPlanning/IntegratedPlanning/index.jsx'));
const EsfForecast = React.lazy(() => import('./components/ExtendedPlanning/ESFForecast/index.jsx'));
const IInsights = React.lazy(()=> import ('./components/Insights/project-management-insights.jsx'))
const InsightsFrameOne = React.lazy(() => import ('./components/PUMCHome/fullValueChain/insights/insights.jsx'))


const PrivateRoutes = () => {
  const auth = localStorage.getItem('loggedInUser')
  return (
    auth ? <Outlet /> : <Navigate to='/login' />
  )
}

function Loading() {
  return <Loader loading={true}/>;
}

export default function Router() {

  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ForgotPassword />} />



       

          <Route element={<PrivateRoutes />}>
            <Route path="/home/*" element={<Layout />} />
              <Route path="/app" element={<Layout />} >
              <Route index element={<PUMCHome />} />
              <Route path ='/app/fullValueChain' element={<Home module={'fullValueChain'}/>} />
              <Route path ='/app/insights-fvc' element={< InsightsFrameOne />} />
              <Route path="/app/insights" element={<Insights />} />
              <Route path="/app/pumc-insights" element={<PUMCInsights />} />
              <Route path="/app/detailed-insights" element={<IInsights />} />
              <Route path="user-management" element={<UserManagement />} />
              <Route path="/app/financials" element={<Financials />}/>
              <Route path="/app/receivables" element={<Receivables />}/>
              <Route path="/app/user-reports" element={<UserReports />} />
              <Route path="/app/analytic-studio" element={<AnalyticStudio/>} />
              <Route path="/app/planning" element={<Planning />}/>
              <Route path="/app/employees" element={<Employees />}/>
              <Route path ='/app/asset-management' element={<AssetManagement />} />
              <Route path="/app/data-mgt" element={<DataMgt />}/>
              <Route path="/app/data-mgt/pl-file-upload" element={<PLFileUpload />}/>
              <Route path="/app/data-mgt/ai-anomaly-detection" element={<AIAnomalyDetection />}/>

              <Route path ='/app/gas-production' element={<Home />} />
              <Route path ='/app/reserves' element={<Reserves />} />
              <Route path ='operational-excellence' element={<OperationalExcellence />} />
              <Route path ='/app/ceo-dashboards' element={<CEODashboards />} />
              <Route path ='/app/technology-capability' element={<TechnologyCapability />} />
              <Route path ='/app/stakeholders' element={<Stakeholders />} />
              <Route path ='/app/pm-insights' element={<PMInsights />} />
              <Route path="/app/data-mgt/msp-file-upload" element={<MSPFileUpload />}/>
              
              <Route path="/app/data-mgt/raw-data-uploads" element={<RAWDataUploads />}/>

              <Route path="/app/contracts" element={<Contracts />} />
              <Route path="/app/project-management" element={<ProjectManagement />} />
              
              <Route path="/app/customers" element={<CustomersDashboard />} />

              <Route path ='/app/initiatives' element={<InitiativesLanding />} />
              <Route path ='/app/initiatives/create' element={<CreateInitiativesLanding />} />
              <Route path ='/app/initiatives/cadence-board' element={<CadenceBoardInitiativesLanding />} />
              <Route path ='/app/initiatives/view' element={<ViewInitiativesLanding />} />
              <Route path ='/app/initiatives/fcfImpact' element={<FCFImpactLanding />} />

              <Route path ='/app/planning/functional-planning' element={<FunctionalPlanning />} />
              <Route path ='/app/planning/simulation-based' element={<SimulationPlanning />} />
              <Route path ='/app/planning/kpi-based' element={<KpiBasedPlanning />} />
              <Route path ='/app/planning/detailed' element={<DetailedPlanning />} />
              <Route path ='/app/planning/integrated-planning' element={<IntegratedPlanning />} />
              <Route path ='/app/planning/esf-forecast' element={<EsfForecast />} />

              <Route path = '/app/ai-solutions' element={<AISolutions />} />


            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </Suspense>

  );
}
